import { KatSpinner } from '@amzn/katal-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Status } from 'src/models/AuthContextModels';
import { RootState } from 'src/store/store';
import AccessRestricted from './AccessRestricted';

// Routes accessible for a user without access to any business groups
const ALLOWED_PATHS_FOR_USERS_WITHOUT_ACCESS = ['/request-access', '/my-requests'];

const AuthWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUserAccessLoadingStatus, currentUserNotFound } = useSelector((state: RootState) => state.xptAccessAndAuthorizationStore);
  const { pathname } = useLocation();

  if (currentUserAccessLoadingStatus === Status.Loading) {
    return <KatSpinner size="large" />;
  }

  if ((currentUserAccessLoadingStatus === Status.Completed || currentUserAccessLoadingStatus === Status.Failed) && currentUserNotFound
      && !ALLOWED_PATHS_FOR_USERS_WITHOUT_ACCESS.includes(pathname)) {
    return <AccessRestricted />;
  }

  return <>{children}</>;
};

export default AuthWrapper;
